<template lang="pug">
.mt-20.text-center
  img.my-15(
    :src="emptyStateImage"
    alt="No work break policies"
    height="230"
  )
  h4.my-0
    | No active work break policies
  p.text-lighter.mb-30.text-13
    | Set up automatic work break policies
</template>
<script>
import { IMAGE_NO_WORK_BREAK_POLICIES } from '~/rails_assets';

export default {
  data: () => ({
    emptyStateImage: IMAGE_NO_WORK_BREAK_POLICIES,
  }),
};
</script>
